import { render, staticRenderFns } from "./sloth.vue?vue&type=template&id=d4218f9a&scoped=true&"
import script from "./sloth.vue?vue&type=script&lang=js&"
export * from "./sloth.vue?vue&type=script&lang=js&"
import style0 from "./sloth.vue?vue&type=style&index=0&id=d4218f9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4218f9a",
  null
  
)

export default component.exports